import React from 'react';

import ProductPurchaseCard from './productPurchaseCard/ProductPurchaseCard';

export default class ProductPurchase extends React.PureComponent {
  constructor(props) {
    super(props);

    const initialVariant = props.initialVariant && props.product.variants.find(it => it.code === props.initialVariant);

    this.state = {
      selectedVariant: initialVariant || props.product.variants[0],
      purchaseParams: {},
      eventParams: props.initialOccurrence || {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.product && nextProps.product !== this.props.product) {
      this.onChange({selectedVariant: nextProps.product.variants[0], purchaseParams: {}, eventParams: {}});
    }
  }

  onChange = params => {
    const {occurrences} = this.props;
    const {selectedVariant} = params;

    if (occurrences && selectedVariant) {
      if (!occurrences.some(occurrence => occurrence.productVariant.code === selectedVariant.code)) {
        return this.setState({...params, eventParams: {}});
      }
    }

    this.setState(params);
  };

  onPurchase = () => {
    const {onPurchase} = this.props;
    const {selectedVariant, purchaseParams, eventParams} = this.state;

    const {error, ...sanitizedVariantParams} = purchaseParams;
    const sanitizedEventParams = {event: eventParams.id, eventOccurrence: eventParams.occurrence};

    onPurchase({variant: selectedVariant.id, ...sanitizedVariantParams, ...sanitizedEventParams});
  };

  render() {
    const {product, occurrences} = this.props;
    const {selectedVariant, purchaseParams, eventParams} = this.state;

    return (
      <ProductPurchaseCard
        product={product}
        occurrences={occurrences}
        selectedVariant={selectedVariant}
        purchaseParams={purchaseParams}
        eventParams={eventParams}
        onChange={this.onChange}
        onPurchase={this.onPurchase}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/productPurchase/ProductPurchase.js